const CHECKOUT_SCRIPT_SRC = "https://checkout.razorpay.com/v1/checkout.js";

let loadPromise = null;

/** Injects the Razorpay Checkout.js script once; resolves once window.Razorpay is ready. */
export function loadRazorpayScript() {
  if (typeof window !== "undefined" && window.Razorpay) {
    return Promise.resolve(true);
  }
  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${CHECKOUT_SCRIPT_SRC}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve(true));
      existing.addEventListener("error", () => reject(new Error("Failed to load Razorpay Checkout")));
      return;
    }
    const script = document.createElement("script");
    script.src = CHECKOUT_SCRIPT_SRC;
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => reject(new Error("Failed to load Razorpay Checkout"));
    document.body.appendChild(script);
  }).catch((error) => {
    loadPromise = null;
    throw error;
  });

  return loadPromise;
}

/**
 * Loads Checkout.js if needed, then opens a Razorpay payment sheet with the given options.
 * Pass `onFailure` to be notified of a declined/failed attempt (Razorpay's own modal already
 * lets the user retry the same order; this is for surfacing a message in the host page too).
 */
export async function openRazorpayCheckout({ onFailure, ...options } = {}) {
  await loadRazorpayScript();
  const instance = new window.Razorpay(options);
  if (onFailure) {
    instance.on("payment.failed", onFailure);
  }
  instance.open();
  return instance;
}
